import { render, staticRenderFns } from "./WarningV2.vue?vue&type=template&id=2557b1f9"
import script from "./WarningV2.vue?vue&type=script&lang=js"
export * from "./WarningV2.vue?vue&type=script&lang=js"
import style0 from "./WarningV2.vue?vue&type=style&index=0&id=2557b1f9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports